import { PopupApiDto } from '@b2x/storefront-api-js-client/src/dto';
import { Alignment } from '@floating-ui/dom';
import classnames from 'classnames';

import { PopupBuilderButtonContentSection, PopupContentTypeV2 } from '../contentTypes';
import { Div } from '../HTMLElement';
import { ModalButton } from '../Modal';
import { buildSpacingClassNamesFromContent, buildVisibilityClassNamesFromContent } from '../util';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';
import { popupBuilderButtonToModalButtonProps } from './popupHelper';

export interface PopupBuilderButtonComponentProps extends PopupBuilderButtonContentSection {
  popup: PopupApiDto<PopupContentTypeV2>;
}

const PopupBuilderButtonComponent = ({ button, options, popup }: PopupBuilderButtonComponentProps) => {
  const alignment = options?.alignment as Alignment | undefined;
  const margin = options?.margin && buildSpacingClassNamesFromContent('m', options.margin);
  const visibility = options?.visibility;
  const visibilityClassNames = visibility && buildVisibilityClassNamesFromContent(visibility);

  const buttonProps = button && popupBuilderButtonToModalButtonProps(button, popup);

  return (
    <Div
      className={classnames('popup-builder-button-component', options?.classes)}
      display="flex"
      justifyContent={alignment}
      uiClassName={{ bs5: classnames(margin, visibilityClassNames) }}
    >
      <ModalButton {...buttonProps} />
    </Div>
  );
};

export type PopupBuilderButtonComponentVariants = '';

const PopupBuilderButtonComponentController = (props: PropsWithCustomComponent<PopupBuilderButtonComponentProps>) => (
  <VariantsController<PopupBuilderButtonComponentProps, PopupBuilderButtonComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderButtonComponent,
      name: 'PopupBuilderButtonComponent',
    }}
  />
);
export { PopupBuilderButtonComponentController as PopupBuilderButtonComponent };
